// extracted by mini-css-extract-plugin
export default {"editAddressWrap":"editAddressWrap___QmWDP","addressDetailInput":"addressDetailInput___tcN6Z"};